import type { NextFunction } from 'express';

import { login } from '../../actions/auth';

export default function () {
  return (next: NextFunction) => (action: ReturnType<typeof login.rejected>) => {
    if (action.type === login.fulfilled.type && action.payload) {
      const { host, key } = action.payload.data;

      if (host && key) {
        //redirectKey - нельзя менять этот ключ т.к на него будут завязаны сторонние ландинги
        const url = `${host}?redirectKey=${key}`;
        window.location.replace(url);
      }
    }
    return next(action);
  };
}
